import { NgClass } from '@angular/common';
import { Component, Input, input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-terms-and-conditions',
  standalone: true,
  imports: [TranslateModule, NgClass],
  templateUrl: './terms-and-conditions.component.html',
  styleUrl: './terms-and-conditions.component.scss',
})
export class TermsAndConditionsComponent {
  @Input() showCloseBtn: boolean = false;
  constructor(public activeModal: NgbActiveModal) {
  }
}
